import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import { PolicySequencesTab } from "../../../../../emailSequences/components/PolicySequencesTab";

export const CommAutoSequencesRoutes = [
  {
    path: "/comm-automobile-policy/:customerId/sequences/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <PolicySequencesTab />
      </AuthorizedRoute>
    ),
  },
];
